export const AvatarNavbarPeopleIcon = ({
  className = '',
}: {
  className?: string
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1461_6411)">
        <path
          d="M15.63 18.13H19.38V14.1C19.38 13.82 19.28 13.55 19.11 13.33C18.94 13.11 18.7 12.96 18.43 12.89L14.38 11.88L14.06 9.66C14.71 9.36 15.27 8.88 15.65 8.28C16.04 7.67 16.25 6.97 16.25 6.25V5.16C16.27 4.27 15.97 3.4 15.42 2.69C14.87 1.99 14.09 1.51 13.22 1.32C12.56 1.19 11.88 1.24 11.25 1.46"
          stroke="#737373"
          strokeWidth="1.15"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.22 14.74L8.75 13.75L8.43 11.53C9.04 11.63 9.66 11.6 10.25 11.44C10.84 11.28 11.4 11.01 11.88 10.63C10.95 9.36 10.5 7.81 10.63 6.25C10.63 5.26 10.23 4.3 9.53 3.6C8.82 2.9 7.87 2.5 6.88 2.5C5.88 2.5 4.93 2.9 4.22 3.6C3.52 4.3 3.13 5.26 3.13 6.25C3.25 7.81 2.8 9.36 1.88 10.63C2.35 11.01 2.91 11.28 3.5 11.44C4.09 11.6 4.71 11.63 5.32 11.53L5 13.75L1.53 14.74C1.27 14.82 1.04 14.97 0.88 15.19C0.71 15.41 0.63 15.67 0.63 15.94V18.13H13.13V15.94C13.12 15.67 13.04 15.41 12.87 15.19C12.71 14.97 12.48 14.82 12.22 14.74Z"
          stroke="#737373"
          strokeWidth="1.15"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1461_6411">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
